export default __webpack_public_path__ + "static/media/gas-paid-logo.c9cc8837.svg";